import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { shieldOff } from "@tql/ui-components-react/untitled/icons";

import * as styles from "./liability-warning-banner.module.css";

export function LiabilityWarningBanner() {
	return (
		<div className={styles.liabilityWarningBanner} role={"alert"}>
			<SvgIcon icon={shieldOff} />
			<span>
				Carrier&rsquo;s minimum liability does not cover the shipment value.
			</span>
		</div>
	);
}
